import { staticDataLanguageDetailsIdEnum } from 'modules/common/enums';

export const staticDataInterestsMapper = interests => {
  const mappedData = {};

  interests.forEach(interest => {
    mappedData[interest.interestKey] = interest.languageDetails.find(
      interestLanguage => interestLanguage.languageId === staticDataLanguageDetailsIdEnum.english,
    ).name;
  });

  return mappedData;
};

export const staticDataTitlesMapper = doctorTitles => {
  const mappedData = {};

  doctorTitles.forEach(title => {
    mappedData[title.doctorTitleKey] = title.languageDetails.find(
      titleLanguage => titleLanguage.languageId === staticDataLanguageDetailsIdEnum.english,
    ).name;
  });

  return mappedData;
};

export const staticDataSpecialtiesMapper = specialties => {
  const mappedData = {};

  specialties.forEach(specialty => {
    mappedData[specialty.specialtyKey] = specialty.languageDetails.find(
      specialtyLanguage => specialtyLanguage.languageId === staticDataLanguageDetailsIdEnum.english,
    ).name;
  });

  return mappedData;
};

export const staticDataCountriesMapper = countries => {
  const mappedData = {};

  countries.forEach(country => {
    mappedData[country.countryKey] = country.languageDetails.find(
      countryLanguage => countryLanguage.languageId === staticDataLanguageDetailsIdEnum.english,
    ).name;
  });

  return mappedData;
};

export const staticDataNationalitiesMapper = nationalities => {
  const mappedData = {};

  nationalities.forEach(nationality => {
    mappedData[nationality.nationalityKey] = nationality.languageDetails.find(
      nationalityLanguage =>
        nationalityLanguage.languageId === staticDataLanguageDetailsIdEnum.english,
    ).name;
  });

  return mappedData;
};

export const staticDataEntityTypesMapper = entityTypes => {
  const mappedData = {};

  entityTypes.forEach(entityType => {
    mappedData[entityType.entityTypeKey] = entityType.languageDetails.find(
      entityTypeLanguage =>
        entityTypeLanguage.languageId === staticDataLanguageDetailsIdEnum.english,
    ).name;
  });

  return mappedData;
};

export const staticDataCompanyTypesMapper = companyTypes => {
  const mappedData = {};

  companyTypes.forEach(companyType => {
    mappedData[companyType.companyTypeKey] = companyType.languageDetails.find(
      companyTypeLanguage =>
        companyTypeLanguage.languageId === staticDataLanguageDetailsIdEnum.english,
    ).name;
  });

  return mappedData;
};

export const staticDataIndustriesMapper = industries => {
  const mappedData = {};

  industries.forEach(industry => {
    mappedData[industry.industryKey] = industry.languageDetails.find(
      industryLanguage => industryLanguage.languageId === staticDataLanguageDetailsIdEnum.english,
    ).name;
  });

  return mappedData;
};
